import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the "Receive" cost centers this user can receive old stock into
export const getOldStockIssueReceivedCCs = async (UID, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetoldstockissueRecievedccs?UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the pending-receipt Indent numbers for a cost center
export const getOldIssueRecIndentsbyCC = async (CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetoldIssueRecIndentsbyCC?CCCode=${encodeURIComponent(CCCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the read-only preview grid (item, spec, qty, amount, depreciation %) for a CC + Indent
export const getOldItemsIssueReceivedDetails = async (CCcode, Indent) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/OldItemsIssueReceivedDetails?CCcode=${encodeURIComponent(CCcode)}&Indent=${encodeURIComponent(Indent)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the expected receipt date for an Indent (shown read-only alongside the received date)
export const getOldStockReceivedExpDate = async (Indentno) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/Getoldstockrecievedexpdate?Indentno=${encodeURIComponent(Indentno)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the receipt for every pending item under this CC + Indent
// payload: { SCCCode, SDate, SRemarks, SIndentno, RoleID, Createdby }
export const saveOldItemsIssueReceived = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveOldItemsIssueReceived`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};
